import React from 'react';
import styled from "styled-components";
import {Typewriter} from 'react-simple-typewriter';
import {useNavigate} from "react-router-dom";
import {BsArrowRight} from "react-icons/bs";
import ProfilePic from "../assets/ProfilePicaFB-removebg.png";
import BackgroundOne from "../assets/bg2.png";
import LogoZT from "../assets/logoZT.png";
// import BackgroundSmoke from "../assets/smoke.png";
import { AiOutlineHtml5 } from "react-icons/ai";
import { IoLogoCss3 } from "react-icons/io";
import { IoLogoJavascript } from "react-icons/io";
import { FaReact } from "react-icons/fa";
import { FaJava } from "react-icons/fa";

import {device} from "../components/Devices";

function Home() {

    const navigate = useNavigate();

    const routeChange = () => {
        let path = "/contact";
        navigate(path);
    }

    return (
        <Main_Home_Container>
            <section
                style={{
                    backgroundImage: `url(${BackgroundOne})`,
                    backgroundSize: "cover"
                }}
            >
                <div>
                    <h2 className="center_of_agile">Center_Of_Agile</h2>

                    <h3>Hi, I'm</h3>
                    <h1>Dennis Rijkers
                        {/*<span>MBA</span>*/}
                    </h1>
                    <h2><Typewriter
                        words={['Agile Coach', 'Scrum Master', 'FE / FullStack Developer', 'Artist', 'DJ/Producer']}
                        cursor
                        cursorStyle='_'
                        typeSpeed={70}
                        deleteSpeed={50}
                        delaySpeed={1200}
                        loop="infinitely"
                    />
                    </h2>
                    <button
                        onClick={routeChange}
                    >Contact Me<BsArrowRight

                        style={{
                            fontSize: "15",
                            alignSelf: "center",
                        }
                        }

                    /></button>

                </div>

                <img src={ProfilePic} alt=""/>

                <aside>
                    <AiOutlineHtml5 />
                    <IoLogoCss3 />
                    <IoLogoJavascript />
                    <FaReact />
                    <FaJava />
                </aside>


            </section>

            <section className="about_me_section">
                <img src={LogoZT} alt=""/>
                <h2>Abou<span>t Me</span></h2>
                <p>After my HEAO and Master of Business Administration I grew into the Agile world. I had roles like
                    Business Analyst and Process Manager, but I saw those roles changing over time in Agile
                    environments. I like change so I took it to heart and developed myself in this Agile world. The last
                    couple of years I developed myself (professionally) as an Agile Coach.
                    <br/>
                    <br/>
                    I work with IT teams and my fascination about how they do their work and build nice stuff for
                    customers got me hooked in developing myself as well. As a hobby I picked up some Frontend
                    programming, but after lately I wanted more depth and maybe combine this growing knowledge into my
                    work field. Currently I am half way a FullStack dev bootcamp. I just finished my Frontend project
                    (which you can find on this webpage) and starting on the Backend, Java soon. As result I am building
                    private projects and this portfolio is one of them. Still learning, but having fun at it.</p>

                <h3>Best,</h3>
                <h4>Dennis</h4>


            </section>

        </Main_Home_Container>
    );
}

export default Home;

const Main_Home_Container = styled.div`

  height: auto;
  width: auto;
  min-width: 320px;
  max-width: 320px;
  background-color: transparent;
  //margin: 10px;
  margin-top: 90px;

  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  //border: 1px solid black;

  @media ${device.mobileM} {
    max-width: 375px;
  }

  @media ${device.mobileL} {
    max-width: 425px;
  }

  @media ${device.tablet} {
    max-width: 768px;
  }

  @media ${device.laptop} {

    max-width: 1024px;
  }

  @media ${device.laptopL} {
    max-width: 1440px;
  }

    // @media ${device.desktop} {
  //   max-width: 2560px;
  //
  // }


  section {

    width: auto;
    max-width: 320px;
    min-width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;

    background: url("../assets/bg2.png");
    object-fit: cover;

    overflow: hidden;

    @media ${device.mobileS} {
      height: 200px;

    }

    @media ${device.mobileM} {
      max-width: 375px;

    }

    @media ${device.mobileL} {
      max-width: 425px;
    }

    @media ${device.tablet} {

      max-width: 768px;
      height: 350px;

    }

    @media ${device.laptop} {

      max-width: 1024px;
    }

    @media ${device.laptopL} {
      max-width: 1440px;
      height: 400px;
      width: 1400px;
    }

      // @media ${device.desktop} {
    //   max-width: 2560px;
    //   width: 1800px;
    //
    // }


    div {

      width: auto;
      height: auto;
      margin-top: 0;
      min-width: 200px;
      //min-height: 400px;
      position: absolute;
      //border: 1px solid black;
      padding: 5px;

      @media ${device.mobileM} {
        max-width: 375px;
      }

      @media ${device.mobileL} {
        max-width: 425px;
      }

      @media ${device.tablet} {

        max-width: 768px;

      }

      @media ${device.laptop} {

        max-width: 1024px;
      }

      @media ${device.laptopL} {
        max-width: 1440px;

        margin-left: 50px;
      }

      .center_of_agile {

        opacity: 0.2;
        margin-bottom: 10px;

        @media ${device.tablet} {

          margin-bottom: 30px;

        }

        @media ${device.laptop} {

          margin-bottom: 30px;

        }

        @media ${device.laptopL} {

          font-size: 60px;
          margin-bottom: 50px;

        }

      }


      h1 {
        color: var(--mainTextColor);
        font-weight: bolder;
        margin: 10px 0;
        width: auto;

        @media ${device.tablet} {

          font-size: 50px;

        }

        @media ${device.laptopL} {
          font-size: 60px;
        }

        span {
          font-weight: lighter;
          font-size: 15px;
        }
      }

      h2 {
        color: var(--orange);
        font-weight: lighter;
        width: auto;
        margin-bottom: 20px;

        @media ${device.tablet} {

          font-size: 40px;
        }

      }

      h3 {
        color: var(--mainTextColor);
        font-weight: lighter;
        width: auto;


        @media ${device.tablet} {

          font-size: 25px;
        }


      }

      button {
        margin: 0;
        padding: 5px 10px;
        width: auto;
        font-size: 12px;
        font-weight: lighter;
        border-radius: 10px;
        border: 1px solid var(--orange);
        background-color: transparent;
        color: var(--mainTextColor);

        display: flex;
        justify-content: space-evenly;
        align-content: center;

        cursor: pointer;

        @media ${device.tablet} {

          margin-top: 80px;
          font-size: 25px;
          width: 250px;

        }

        @media ${device.laptop} {

        }

        &:hover {
          background-color: var(--orange);
          color: var(--mainBackGroundColor);
        }
      }
    }


    img {
      width: auto;
      height: auto;
      margin-left: 120px;


      @media ${device.mobileM} {
        margin-left: 170px;
      }

      @media ${device.mobileL} {
        margin-left: 180px;
      }

      @media ${device.tablet} {

        margin-left: 425px;
      }

      @media ${device.laptop} {

        margin-left: 690px;
      }

      @media ${device.laptopL} {
        margin-left: 950px;

      }


    }
    //logos
    
    aside {
      position: absolute;
      right: 0;
      font-size: 20px;
      color: var(--blackShadow);
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 20px;
      opacity: 0.3;
    }

  }

  .about_me_section {
    height: auto;
    min-height: auto;
    //border: 1px double var(--dimGrey);
    margin-top: 25px;
    padding: 10px;

    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 370px;
    position: relative;

    img {

      position: absolute;
      object-fit: fill;
      opacity: 0.05;
      top: 0;
      left: 0;
      right: 0;
      margin-left: 0;
      height: 100%;
      width: 100%;

    }

    @media ${device.tablet} {
      max-width: 768px;

    }

    @media ${device.laptop} {

      max-width: 1024px;
    }


    h2 {
      color: var(--mainTextColor);
      margin-bottom: 20px;
      font-weight: lighter;

      @media ${device.tablet} {

        font-size: 50px;
        
      }

      @media ${device.laptopL} {
        font-size: 60px;

      }


      span {
        border-bottom: 2px solid var(--orange);
      }

    }

    h3 {
      color: var(--mainTextColor);
      font-weight: lighter;
      margin-top: 9px;

      @media ${device.tablet} {

        font-size: 25px;
      }

      @media ${device.laptopL} {
        font-size: 30px;

      }


    }

    h4 {
      color: var(--mainTextColor);
      font-weight: lighter;
      font-size: 21px;

      @media ${device.tablet} {

        font-size: 25px;
      }

      @media ${device.laptopL} {
        font-size: 35px;

      }


    }

    p {
      color: var(--blackShadow);
      line-height: 20px;
      font-weight: lighter;
      font-size: 18px;

      @media ${device.tablet} {

        font-size: 25px;
        line-height: 25px;
      }

      @media ${device.laptopL} {
        line-height: 30px;

      }


    }


  }

`;

